import React from 'react'
import classes from "./Wmd.module.css";
import f from "./../../Assest/tnf.jpg"

const Wmd = () => {
  return (
    <div>
       <div className={classes.container}>
            <div className={classes.leftPanel}>
                <h1 className={classes.title}>What Makes RCG Different?</h1>
                <p className={classes.text}>
                    RCG (Rushikesh Career Guidance) offers complete career guidance solutions under one roof. We provide expert counselling, accurate assessments, and admission support while maintaining the highest standards of transparency and quality. Whether you are a school student, a college aspirant, or a parent seeking clarity, we bring the expertise and structured approach needed to make confident career decisions.
                </p>
                <p className={classes.text}>
                    Our team of experienced, student-focused counsellors is committed to delivering result-oriented guidance. We help students identify the right career paths, select suitable courses and institutions, and successfully navigate the admission process. Through personalized mentoring and well-defined strategies, we empower students to achieve their academic and professional goals.
                </p>
                    <p className={classes.text}>
                   As part of our guidance process, we emphasize in-depth analysis, aptitude evaluation, and careful planning. This enables students to make informed choices, build strong career foundations, and move toward their goals with clarity, confidence, and speed.
                </p>
                <br/><br/><br/>
            </div>
            <div className={classes.rightPanel}>
                <img 
                    src={f}
                    alt="A digital representation of eshikatech" 
                    className={classes.image} 
                />
            </div>
        </div>
    </div>
  )
}

export default Wmd
